import React from 'react';
import { Search, Settings, Rocket, CheckCircle } from 'lucide-react';
import { CharReveal, TiltCard, Reveal } from './TerminalEffects';

const STEPS = [
  { icon: Search, step: '01', title: 'Discover & Analyse', description: 'We dive deep into understanding your business needs, workflow, and customer interaction patterns to create the perfect AI solution.', accent: '#7DFFD4' },
  { icon: Settings, step: '02', title: 'Customise & Build', description: 'Our team creates a tailored AI system specifically designed for your business — from voice personality to conversation flows.', accent: '#C4956A' },
  { icon: Rocket, step: '03', title: 'Deploy & Launch', description: 'We launch your AI assistant with comprehensive training, seamless integration, and full support throughout the process.', accent: '#00FFD1' },
  { icon: CheckCircle, step: '04', title: 'Optimise & Scale', description: 'Continuous monitoring, regular performance reviews, and ongoing optimisation keep your AI performing at its best as you grow.', accent: '#D4F7DC' },
];

export const HowItWorksSection = () => (
  <section className="relative py-28 bg-[#FAF8F4] overflow-hidden" data-testid="howitworks-section">
    <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
      <Reveal>
        <div className="mb-20 max-w-[600px]">
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#C4956A] mb-4">How It Works</p>
          <CharReveal text="From Concept to Implementation" tag="h2"
            className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#2A2A2A] leading-[1.05]" />
        </div>
      </Reveal>
      <div className="relative">
        {/* Connecting line behind cards */}
        <div className="hidden lg:block absolute top-[60px] left-[60px] right-[60px] h-[2px] bg-gradient-to-r from-[#7DFFD4]/40 via-[#C4956A]/40 via-[#00FFD1]/40 to-[#D4F7DC]/40" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative z-10">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.step} delay={i * 120}>
                <TiltCard accentColor={s.accent} className="h-full">
                  <div className="bg-[#1e1e1e] rounded-2xl p-8 flex flex-col h-full relative overflow-hidden"
                    data-testid={`step-card-${i}`}>
                    <div className="text-5xl font-bold mb-4 opacity-20" style={{ color: s.accent, fontFamily: "'Outfit', sans-serif" }}>{s.step}</div>
                    <div className="w-10 h-10 rounded-full flex items-center justify-center mb-5" style={{ backgroundColor: `${s.accent}20` }}>
                      <Icon size={18} style={{ color: s.accent }} />
                    </div>
                    <h3 className="text-lg font-semibold text-[#F5F0E0] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>{s.title}</h3>
                    <p className="text-sm text-[#F5F0E0]/60 leading-relaxed flex-1" style={{ fontFamily: "'Manrope', sans-serif" }}>{s.description}</p>
                  </div>
                </TiltCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
